import React from 'react';
import style from './about.module.less';
import Skills from '../PageFragments/HomePage/SkillProgress';

const AboutTile = (props) => {
  const {
    img, textH4, textH3, alt, height, width, githubSrc,
    python, cpp, ros, sim, ml, cad, matlab, embedded,
  } = props;

  return (
    <a href={githubSrc}>
      <div className={style.aboutTile}>
        <div className={style.aboutBlock}>
          <img
            src={`../${img}`}
            height={height || 64}
            width={width || 64}
            alt={alt || ''}
          />
        </div>
        <div className={`textCenter ${style.mrTp26PX}`}>
          <h3>{textH3 || ''}</h3>
          <p>{textH4 || ''}</p>
        </div>
        <Skills
          python={python}
          cpp={cpp}
          ros={ros}
          sim={sim}
          ml={ml}
          cad={cad}
          matlab={matlab}
          embedded={embedded}
        />
      </div>
    </a>
  );
};

export default AboutTile;
